import { Typography } from "antd"
import type { TableProps } from "antd"
import { BulkWalletEntryMode, OrderType } from "~/common/constants"
import { formatAmount, formatDateTime, getEnumLabel } from "~/common/utils"
import {
  bulkEntryModeLabel,
  orderStatusLabel,
  orderTypeLabel,
  productCodeLabel,
} from "~/pages/Staff/labels"
import { getOrderWalletAmount } from "~/common/billing/labels"
import styles from "./index.css"

export const columns: TableProps<API.Staff.OrderListItem>["columns"] = [
  {
    title: "交易时间",
    dataIndex: "paid_at",
    width: 180,
    render: formatDateTime,
  },
  {
    title: "订单编号",
    dataIndex: "order_no",
    width: 280,
    render: (value: string) => (
      <Typography.Text
        className={styles.orderNo}
        copyable={{ text: value, tooltips: ["复制订单编号", "已复制"] }}
        ellipsis={{ tooltip: value }}
      >
        {value}
      </Typography.Text>
    ),
  },
  {
    title: "订单类型",
    dataIndex: "order_type",
    width: 130,
    render: (value: API.Staff.OrderListItem["order_type"]) =>
      getEnumLabel(orderTypeLabel, value),
  },
  {
    title: "用户手机号",
    dataIndex: "user_mobile",
    width: 150,
    render: (value?: string | null) => value || "-",
  },
  {
    title: "商品",
    width: 150,
    render: (_, record) => getEnumLabel(productCodeLabel, record.product_code),
  },
  {
    title: "购买积点",
    width: 110,
    render: (_, record) => getOrderWalletAmount(record) ?? "-",
  },
  {
    title: "录入方式",
    width: 130,
    render: (_, record) =>
      record.bulk_wallet_package
        ? bulkEntryModeLabel[
            record.bulk_wallet_package.entry_mode ??
              BulkWalletEntryMode.quantity
          ]
        : "-",
  },
  {
    title: "购买单价（分/积点）",
    width: 155,
    render: (_, record) =>
      record.bulk_wallet_package?.purchase_unit_price ?? "-",
  },
  {
    title: "退款结算单价（分/积点）",
    width: 180,
    render: (_, record) => record.bulk_wallet_package?.refund_unit_price ?? "-",
  },
  {
    title: "权益开始时间",
    width: 180,
    render: (_, record) =>
      formatDateTime(
        record.order_type === OrderType.levelPackage
          ? record.level_package?.level_period_start
          : null,
      ),
  },
  {
    title: "权益结束时间",
    width: 180,
    render: (_, record) =>
      formatDateTime(
        record.order_type === OrderType.levelPackage
          ? record.level_package?.actual_level_period_end
          : null,
      ),
  },
  {
    title: "订单金额",
    dataIndex: "amount",
    width: 120,
    align: "right",
    render: formatAmount,
  },
  {
    title: "订单状态",
    dataIndex: "status",
    width: 120,
    render: (value: API.Staff.OrderListItem["status"]) =>
      getEnumLabel(orderStatusLabel, value),
  },
]
